module.exports = __webpack_public_path__ + "img/block_1.fd026b24.webp";